module.exports = __webpack_public_path__ + "static/img/green.efc2559d.png";